function addToObject(obj, key, value, afterKey) {
    const temp = {};

    Object.keys(obj).map((propName) => {
        if (propName === afterKey && key && value) {
            temp[key] = value;
        }

        temp[propName] = obj[propName];
    });

    if (!afterKey && key && value) {
        temp[key] = value;
    }

    return temp;
}

function isObject(something) {
    return typeof something === 'object' && something !== null;
}

export {addToObject, isObject};
